import { render, staticRenderFns } from "./pbx-base.vue?vue&type=template&id=5793acea"
import script from "./pbx-base.vue?vue&type=script&lang=js"
export * from "./pbx-base.vue?vue&type=script&lang=js"
import style0 from "./pbx-base.vue?vue&type=style&index=0&id=5793acea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports